<template>
  <div v-loading="loading" class="ec-line041">
    <form-supplier-apply v-model="customerInfo" @handle-submit="handleSubmit"></form-supplier-apply>
  </div>
</template>

<script>
import formSupplierApply from '@/components/ec-line041/formSupplierApply.vue'
import { AuthService, LineLinkService } from '@/services'
import { trimCommaForm } from '@/utils'
import liff from '@line/liff'
import * as RouterPage from '@/constants/route-page'

const CUSTOMER_INFO_DEFAULT = {
  companyName: '',
  storeName: '',
  lastName: '',
  firstName: '',
  lastNameKana: '',
  firstNameKana: '',
  email: '',
  emailConfirm: '',
  postalCode01: '',
  postalCode02: '',
  prefecture: '',
  municipality: '',
  address: '',
  buildingApartmentName: '',
  phoneNumber: '',
  lineId: '',
}

export default {
  components: {
    formSupplierApply,
  },

  data() {
    return {
      customerInfo: { ...CUSTOMER_INFO_DEFAULT },
      loading: false,
    }
  },

  watch: {
    'customerInfo.companyName'(newVal) {
      this.customerInfo.storeName = newVal
    },
  },

  async created() {
    const profile = await liff.getProfile()

    if (!profile.userId) {
      this.$router.push({ path: RouterPage.PAGE_NOT_FOUND })
    }
  },

  methods: {
    async handleSubmit() {
      this.loading = true

      try {
        const body = await this.getRequestBody(this.customerInfo)
        const { data } = await AuthService.createCustomer(body)
        await LineLinkService.linkAccountBusiness({
          customerId: data.id,
          accessToken: liff.getAccessToken(),
        })

        /**
         * webhookを発火させる為にユーザーとしてメッセージを送信
         * TODO
         * webhookで検知するメッセージが変更になるとデプロイが必要になる為、外部ファイル管理を検討
         * 20241025時点では限定的な利用の為ハードコード
         */
        liff.sendMessages([
          {
            type: 'text',
            text: '申込完了',
          },
        ])

        liff.closeWindow()
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    getRequestBody(form) {
      const customer = {
        name01: form.lastName || null,
        name02: form.firstName || null,
        kana01: form.lastNameKana || null,
        kana02: form.firstNameKana || null,
        email: form.email,
        postal_code: [form.postalCode01, form.postalCode02].join(this.$t('common.hyphenSeparator')),
        pref_id: form.prefecture || null,
        addr01: form.municipality || null,
        addr02: form.address || null,
        addr03: form.buildingApartmentName || null,
        phone_number: form.phoneNumber || null,
        company_name: form.companyName || null,
        store_name: form.storeName || null,
        customer_status: 1,
        business_account_flag: true,
      }
      return {
        ...trimCommaForm(customer),
        country_id: this.Constants.DEFAULT_COUNTRY_ID,
      }
    },
  },

  metaInfo() {
    return {
      title: this.$t('ec-line041.pageTitle'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line041.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line041.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
